import { useState } from "react";
import { /*Button, Offcanvas,*/ Tab, Tabs } from "react-bootstrap";
// import { ShowChartOutlined } from "@mui/icons-material";
// import BglGraph from "../BglGraph";
// import BpGraph from "../BpGraph";
import BglForm from "../BglForm";
import BloodPressure from "../BloodPressure";
import { BG, BP, MEDICATIONS, WEIGHT } from "../../util/const";
// import DataNavigator from "../../Components/DataNavigator";
import WeightTable from "../WeightTable";
// import WeightGraph from "../WeightGraph";
import EMR from "../EMR";
import Medications from "../Medications";

// Displays a set of tabs, which hold the different types of data for the patient
const PatientData = () => {

  const [key, setKey] = useState("bgl"); // default selected tab
  // const [isGraphShowing, setIsGraphShowing] = useState(false); // graph is hidden
  // const toggleGraphShowing = () => {
  //   setIsGraphShowing(!isGraphShowing);
  // };

  return (
    <div>
      <div className="float-right">
        {key === "bgl" ? <EMR /> : <></>}
        {/* {key !== "insulin" ? (
          <Button type="button" onClick={toggleGraphShowing} className="btn-color me-2">
            <ShowChartOutlined />
          </Button>
        ) : (
          <></>
        )} */}
      </div>
      {/* <Offcanvas
        show={isGraphShowing}
        onHide={toggleGraphShowing}
        placement="end"
        scroll={true}
        backdrop={true}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="data-nav">
            <DataNavigator typeKey={key}></DataNavigator>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {key === "bgl" ? (
            <BglGraph />
          ) : key === "bp" ? (
            <BpGraph />
          ) : key === "weight" ? (
            <WeightGraph />
          ) : (
            <></>
          )}
        </Offcanvas.Body>
      </Offcanvas> */}
      <Tabs
        defaultActiveKey="bgl"
        id="patient-tab"
        className="mb-3"
        onSelect={(k) => {
          setKey(k!);
        }}>
        <Tab eventKey="bgl" title={BG}>
          <BglForm />
        </Tab>
        <Tab eventKey="bp" title={BP}>
          <BloodPressure />
        </Tab>
        <Tab eventKey="weight" title={WEIGHT}>
          <WeightTable />
        </Tab>
        <Tab eventKey="insulin" title={MEDICATIONS}>
          <Medications />
        </Tab>
      </Tabs>
    </div>
  );
};

export default PatientData;
